import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { finalize, map, mergeMap } from 'rxjs/operators';

import { RequestService } from '../../../shared/services/request.service';
import * as RequestActions from '../actions/request.actions';

@Injectable()
export class RequestEffects {
  private readonly actions$ = inject(Actions);
  private readonly requestService = inject(RequestService);
  private readonly router = inject(Router);

  sendManureRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RequestActions.sendManureRequest),
      mergeMap((action) =>
        this.requestService.postRequest(action.request).pipe(
          map((response) => RequestActions.sendManureRequestSuccess({ response })),
          finalize(() => this.router.navigate(['request/confirmation'])),
        ),
      ),
    ),
  );
}
